import { useContext, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

import './FaqPage.css';
import { getRandomId } from '../../assets/utils/utils';
import { ArrowIcon } from '../../assets/icons/icons';
import { QUESTIONS } from '../../assets/utils/constants';

function FaqPage() {

    const [openItemId, setOpenItemId] = useState(QUESTIONS[0]._id);

    const toggleItem = (id) => {
        if (openItemId === id) {
            setOpenItemId(null);
        } else {
            setOpenItemId(id);
        }
    };

    return (
        <div className='faq-page'>
            <h4 className='faq-page__title'>Часто задаваемые вопросы</h4>
            <div className='faq-page__items'>
                {QUESTIONS.map((item, i) => (
                    <button className={`faq-page__item ${openItemId === item._id ? 'faq-page__item_selected' : ''}`} type='button' key={`faq-page__item${item._id}`} onClick={() => toggleItem(item._id)}>
                        <div className='faq-page__item-info'>
                            <p className='faq-page__item-info-question'
                                dangerouslySetInnerHTML={{
                                    __html: item.question,
                                }}
                            ></p>
                            <AnimatePresence mode='sync'>
                                {openItemId === item._id && (
                                    <motion.div
                                        initial={{ opacity: 0, height: 0, y: -20, }}
                                        animate={{ opacity: 1, height: 'auto', y: 0, }}
                                        exit={{ opacity: 0, height: 0, y: -20, }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <p className='faq-page__item-info-answer'
                                            dangerouslySetInnerHTML={{
                                                __html: item.answer,
                                            }}
                                        ></p>
                                    </motion.div>
                                )}
                            </AnimatePresence>
                        </div>
                        <ArrowIcon
                            mainClassName={'faq-page__item-arrow'}
                            fillClassName={'faq-page__item-arrow-fill'}
                        />
                    </button>
                ))}

            </div>
        </div>
    );
}

export default FaqPage